// extracted by mini-css-extract-plugin
export default {"wrapper":"PF5EEYbc6Wh8lLFqodgT","card":"Ykj8flVk7K9rQoqdgX8E","logoContainer":"MLRDC7sjBZMh5kueiqVu","logo":"fgPhb7hjbd2UBFjfDhlT"};